import { render, staticRenderFns } from "./LotteryResultAutoDisplay.vue?vue&type=template&id=42339547&scoped=true&"
import script from "./LotteryResultAutoDisplay.vue?vue&type=script&lang=js&"
export * from "./LotteryResultAutoDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42339547",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
